import _ from 'lodash'
import { List, Map } from 'immutable'
import { toJS } from './common'

export const collectModalsID = (state) => {
  const list = []
  const modals = state.getIn(['project', 'Settings', 'ui', 'Modal'], List())

  modals.map((modalID) => {
    list.push(...collectModalsIDChildren(modalID)(state))
  })

  return _.union(_.compact(list))
}

export const collectModalsIDChildren = (modalID) => (state) => {
  const list = [modalID]
  const elements = state.getIn(['project', 'Settings', 'elements'], Map())

  const processCollectChild = (child) => {
    if (!list.includes(child)) {
      list.push(child)
      let children = elements.getIn([child, 'children'], List())
      children.map(processCollectChild)
    }
  }

  const modal = elements.get(modalID, Map())

  if (modal.getIn(['props', 'isExp'])) {
    _.each(toJS(modal.getIn(['children'], List())) || [], processCollectChild)
  } else {
    _.each(toJS(modal.getIn(['children', 0], List())) || [], processCollectChild)
  }

  return _.union(_.compact(list))
}
